import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import axios from ".././axios-interceptor";
import { base_url } from "./../utilities";
import { useForm } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import Cookies from 'js-cookie';

window.Buffer = window.Buffer || require("buffer").Buffer;
const InvestorKycDocumentsModal = (props) => {
    const navigate = useNavigate();
    if (!Cookies.get("User_Accesstoken_Investor")) {
      navigate('/');
    }
    const [download, setDownload] = useState([]);
    const [file, setUploadFile] = useState(""); //setUploadedUrl
    const [radiotype, setRadioType] = useState("");
    const [url, setUploadedUrl] = useState();
    const [isUpload, setUpload] = useState(false);
    const [radio, setRadio] = useState(false);
    const [investor, setInvestordataUser] = useState([]);
    const handleClose = () => {
        setIsLoading(false)
        setUploadFile("");
        setRadioType("");
        setUploadedUrl();
        setUpload(false);
        setRadio(false);
        props.onHide();
    };
    const {
        handleSubmit,

    } = useForm();
    const [activeTabBool, setActiveTabBool] = useState(false);

    const handleSavechanges = async(data) => {

        const fd1 = new FormData();
        let doctypename;
        if (props.data != null) {
            doctypename = props.data.doc_type;
        }
        if(radio==true){
            doctypename= radiotype;
        }

        if (doctypename == "" || doctypename ==undefined) {
            toast.error('Please select a document type', {
                toastId: 5
            })
        }
        else if (url == "" || url == undefined || url == null) {
            toast.error('Please upload a document', {
                toastId: 5
            })
        }
        else {
            fd1.append('document_type', doctypename)
            fd1.append('created_by', Cookies.get("investor_user_name"))
            fd1.append('investor_id', investor.investor_id);
            setActiveTabBool(true)
            const fileName = file;
            fd1.append('file_name', fileName)
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);
            fd1.append('file', url,fileExtension);
             setIsLoading(true)
            const response = await axios.post(base_url + "documents-type/upload_investor_document", fd1, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.data.status == 200) {
                props.onHide();
                toast.success("Uploaded Successfully", {
                    toastId: 4
                })
                setTimeout(() => {
                    window.location.reload();
                }, 800);
            }

        }
    };

    useEffect(() => {
        axios
        .post(base_url + "investor-master/get_investor_master_user", {
          user_id: Cookies.get("investor_user_id"),
        })
        .then((res) => {
          setInvestordataUser(res.data.data);
            })


        axios
            .post(base_url + "documents-type/get_document_types", {})
            .then((res) => {
                let doctypes = res.data.data;
                let x = [];
                doctypes.INVESTOR_KYC.forEach((element) => {
                    x.push({ doc_type: element, is_upload: false, file_name: "" });
                });
                setDownload(x);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const radioButtonMethod = (e) => {
        setRadioType(e.target.value)
        setRadio(true);
    }


    const handleChange = (event) => {
        if (event.target.files[0].size < 5242880) {
            setUpload(true);
            setUploadFile(event.target.files[0].name);
            setUploadedUrl(event.target.files[0]);
            setUpload(false);
        }
        else {
            toast.error("File size should be less than 5MB", {
                toastId: 7,

            })
        }

    };
    download.forEach((elemCheck) => {
        elemCheck.is_radio = false;
    })
    if (props.data != null) {
        download.forEach((elemCheck) => {
            if (elemCheck.doc_type == props.data.doc_type) {
                elemCheck.is_radio = true;
            }
        })
    }

    const [isLoading, setIsLoading] = useState(false)


    return (
        <Modal
            {...props}
            dialogClassName="modal-190w"
            aria-labelledby="example-custom-modal-styling-title"
            size="md"
            backdrop="static"
            keyboard={false}
            centered
        >

            <Modal.Body className="px-4">
            {isLoading && <div className={ isLoading ?"onClickApplyLoaderStyl" :'d-none'}>
        
          <ThreeDots
          height="70"
          width="70"
          radius="9"
          color="#3d79f3"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
              />
       <br/>
      </div>}
         { isLoading ? <div className="loader_style">Saving...</div>:''}
                <div>
                    
                    <div >                    
                        <div className="row mt-2">
                        <h6 className="mt-3">Document Type</h6>

                            <div className="col-6">
                                {download.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            {index % 2 === 0 &&
                                                <div >
                                                    {item.is_radio == true ? <label onClick={radioButtonMethod} htmlFor={item.doc_type}>
                                                        <input className="style_input_radio " id={item.doc_type} type="radio" value={item.doc_type} defaultChecked name="x" />
                                                        <span className="kyc_style_doc ps-2">{item.doc_type}</span>
                                                    </label>
                                                        : <label onClick={radioButtonMethod} htmlFor={item.doc_type}>
                                                            <input className="style_input_radio " id={item.doc_type} type="radio" value={item.doc_type} name="x" />
                                                            <span className="kyc_style_doc ps-2">{item.doc_type}</span>
                                                        </label>
                                                    }
                                                </div>
                                            }
                                        </div>

                                    );
                                })}
                            </div>

                            <div className="col">
                                {download.map((item, index) => {
                                    return (
                                        index % 2 != 0 && <div key={index}>
                                            {item.is_radio == true ? <label onClick={radioButtonMethod} htmlFor={item.doc_type}>
                                                <input className="style_input_radio " id={item.doc_type} type="radio" value={item.doc_type} defaultChecked name="x" />
                                                <span className="kyc_style_doc ps-2">{item.doc_type}</span>
                                            </label>
                                                : <label onClick={radioButtonMethod} htmlFor={item.doc_type}>
                                                    <input className="style_input_radio " id={item.doc_type} type="radio" value={item.doc_type} name="x" />
                                                    <span className="kyc_style_doc ps-2">{item.doc_type}</span>
                                                </label>
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="h6_style mt-3">Upload Document</div>

                    <div className="d-flex gap-3 my-2">
                        <div>
                            <label className="padding_style">
                                <input type="file" onChange={(e) => handleChange(e)} />
                                {isUpload == false ? <span className="upload_btn"> Click here to select file </span>
                                    : <span className="text_styles_new" style={{ color: "red" }}> Uploading please wait </span>}
                            </label>
                        </div>
                        <div className="upload_file_name"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={file}
                        >{file.length > 25 ? file.slice(0,25)+"..." : file}</div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer >
                <button
                    className="gray_btn"
                    variant="secondary"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                <button
                    className="blue_btn"
                    variant="primary"
                    disabled={activeTabBool}
                    onClick={handleSubmit(handleSavechanges)}
                >
                    Save Document
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default InvestorKycDocumentsModal;